import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { fetchGet, fetchPost } from "../../api/fetch";
import CloseIcon from "../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import Button from '@material-ui/core/Button';

import colors from "../../assets/style/colors";
import Dialog from '@material-ui/core/Dialog';
import VMITree from "./VMITree";
import ScanPopup from "./ScanPopup";
import NuvButton from "../Common/NuvButton";
import images from "../../assets/img/images";

const styles = {
    container: {
        width: 367,
        '@media(max-width: 470px)' : {
            margin: "0",
            padding: "8px",
            borderRadius: "0",
            width: "360px",
            height: "640px",    
      
          }
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
        top: -43
    },
    title: {
        fontSize: 14,
        color: colors.black87,
        fontWeight: 500,
        display: "table",
        margin: "0 auto",
        marginTop: 24
    },
    buttons: {
        display: "table",
        margin: "0 auto",
    },
    scannerButton: {
        marginLeft: 32,
        marginTop: 10,
        marginBottom: 24
    },
    dialogPaper: {
        width: "100%",
        maxHeight: "100%",
        maxWidth: "360px",
    
        margin: 0,
      },


};

const VMIConfiguration = withStyles(styles)((props) => {
    const {
        classes,
        history
    } = props;

    const [scanDialog, setOpenScan] = React.useState(false);
    const [zoneSelected, setZoneSelected] = React.useState();
    
    // Scan Error
    const [scanError, setScanError] = React.useState("")

    async function processRequest() {
        try {
            if (zoneSelected) {
                var res = await fetchGet(`zones/${zoneSelected}`)
                var url = `/wms/vmi-configuration/${zoneSelected}`;
                console.log(res)
                history.push(url);
            } else {
                console.log("zone not selected")
            }
        } catch (error) {
            console.log(error)
        }

    }

    const fetchZoneTree = async (zoneId) => {
        try {
            let res = await fetchGet(
            `zone_tree/zone/${zoneId}?active=true`
            );
            return res
        } catch (e) {
            console.log(e);
        }
    }

    function expandAll(target_id, node, path) {
        if (target_id === node["id"]) {
          return path
        }
    
        for (let i in node["childs"]) {
          if (expandAll(target_id, node["childs"][i], path.concat([node["id"]]))) {
            return (expandAll(target_id, node["childs"][i], path.concat([node["id"]])))
          }
        }
    }

    async function handleZone(zoneId) {
        var url = `/wms/vmi-configuration/${zoneId}`;
        
        if (props.tree){
            expandAll(zoneId, props.tree[0], [])
            history.push(url);
        } else {
            url += `?expandedZones[]=`
            var tree = await fetchZoneTree(zoneId)
            var expandPath = expandAll(zoneId, tree[0], [])
            url += expandPath.join(",");
            // console.log(url)
            setTimeout(500)
            history.push(url);
        }
        setOpenScan(false)
        
      }

    const handleScanDialog = async scanId => {
        if (scanId > 100000) { // Scan PZI ID - Navigate to PZI Location
            
          const body = {
            "description": null,
            "code_product": null,
            "vendor_name": null,
            "ogc": null,
            "category": null,
            "limit": 10,
            "vmi": null,
            "codebin": scanId,
            "pzitbl": true,
          }
    
          try {
            fetchPost("products/search", body)
              .then(product => {
                if (product[0]) {
                    handleZone(product[0]["zone_id"])
                } else {
                    setScanError(I18n.get("profiles_noResultsFound"))
                    setOpenScan(true)
                }
              })
              .catch(e => {
                console.error(e)
              })
          } catch (e) {
            console.log(e);
          }
    
        } else { //Scan Zone ID - Navigate to Zone Location
            handleZone(scanId)
        }
    }


    return (
        <Dialog
            open={true}
            onClose={() => { history.push("/") }}
            aria-labelledby="responsive-dialog-title"
            fullWidth classes={{ paper: classes.dialogPaper}}
        >
            <div className={classes.container}>
                <span className={classes.title}>{I18n.get("sidebar_vmi_config").toUpperCase()}</span>
                <div className={classes.close}>
                    <CloseIcon closeFunction={() => { history.goBack() }} />
                </div>
                <Dialog 
                    PaperProps={{style: {margin: "0"}, }} 
                    open={scanDialog} 
                    onBackdropClick={() => setOpenScan(false)}>
                    <ScanPopup
                        setOpenScan={setOpenScan}
                        errorMsg={scanError}
                        setScanError={setScanError}
                        handleScanDialog={handleScanDialog}
                    />
                </Dialog>
                <div className={classes.scannerButton}>
                    <NuvButton onClick={() => { setOpenScan(true) }} startIcon={<img src={images.scanner} alt="scanner" />}>
                        <span>SCAN</span>
                    </NuvButton>
                </div>
                <div style={{maxHeight: 500, overflowY: "auto"}}>
                    <VMITree zoneSelected={zoneSelected} setZoneSelected={setZoneSelected} />
                </div>
                <div className={classes.buttons}>
                    <Button onClick={() => { history.goBack() }} color="primary">
                        {I18n.get("site_cancel")}
                    </Button>
                    <Button onClick={() => { processRequest() }} style={{ left: "14px" }} variant="contained" color="primary" disabled={!zoneSelected ? true : false}>
                        {I18n.get("site_confirm")}
                    </Button>
                </div>
            </div>
        </Dialog>

    );

});

export default withRouter(VMIConfiguration);
